import companyFormStyles from '@/features/company/styles/companyAdd.module.css'
import { cn } from '@/lib/utils/helpers'

/** Align SearchableSelect trigger with company/property `customFormControl` fields. */
export const transferSearchableTriggerClass = cn(companyFormStyles.customFormControl, "!flex !h-auto min-h-[38px] items-center")

/** Split property — Property Address cards (aligned with legacy two-column physical address layout). */
export const splitPropertyAddressFieldClass = cn(
  "w-full rounded-lg border border-slate-200/90 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm",
  "transition placeholder:text-slate-400",
  "focus:border-[rgb(21_151_255)] focus:outline-none focus:ring-2 focus:ring-[rgb(21_151_255)]/15",
)
export const splitPropertyAddressLabelClass = "mb-1.5 block text-sm font-medium text-slate-700"
